import { render, staticRenderFns } from "./amenities.vue?vue&type=template&id=99dd3d4a"
import script from "./amenities.vue?vue&type=script&lang=js"
export * from "./amenities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports